import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from "react-helmet";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext.js";
import { Cookies } from '../../index.js';
import Pickeroption from './picker';
import View_card from './view_card';
import AdSense from 'react-adsense';
import { FaAngleDoubleUp, FaGoogle, FaUserFriends, FaTelegramPlane } from 'react-icons/fa';
import { FaSpinner, FaCircleNotch, FaSync } from 'react-icons/fa'; // Các biểu tượng loading từ FontAwesome
import { useDispatch, useSelector } from 'react-redux';
import { update_national_market } from '../../order/orders/actions.js';
import ProfileMenu from './profile_menu';

const ProfileComponent = () => {
    // const navigation = useNavigation();

    const [profile, setprofile] = useState('');
    const [money, setmoney] = useState('123');
    const [total_nap, settotal_nap] = useState('123');
    const [username, setusername] = useState('');
    const [namelevel, setnamelevel] = useState('123');
    const [chietkhau, setchietkhau] = useState('123');
    const [limit, setlimit] = useState('Chờ xíu');

    const laythongtin = (apikey) => {
        axios
            .post('https://hust.media/api/profile/profile.php', {
                apikey: apikey,
                chedo: 'getinfo',
            })
            .then(response => testFunction4(response))
            .catch(error => console.log(123 + error));
    };
    const testFunction4 = response => {
        const info = response.data;
        if (info) {
            setprofile(info);
            console.log(info);
            setchietkhau(info.chietkhau);
            setmoney(info.money);
            // document.cookie = `money=${money}`;
            settotal_nap(info.total_nap);
            setusername(info.username);
            setlimit(info.limit);
            setnamelevel(info.namelevel);
        }
    };


    const handleLogout = () => {
        // console.log('Dữ liệu đã bị xóa thành công');

        Cookies.remove('apikey');
        setTimeout(() => {
            const userAgent = navigator.userAgent.toLowerCase();
            const isNative = userAgent.includes("hustmedianative");
            window.location.href = isNative ? '/reactapp/dang-xuat/' : '/reactapp/log_out/';
        }, 100);
        // switch_router("/reactapp/log_out/");
    };
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    // const showauth = useSelector(state => state.showauth);
    // console.log(showauth);

    const [showpicker, setshowpicker] = useState(false);
    const [chedoprofile, setchedoprofile] = useState('');
    const openpicker = (value) => {
        if (value) {
            setchedoprofile(value);
        }
        setshowpicker(true);
    };

    const openGooglelogin = () => {
        const userAgent = navigator.userAgent.toLowerCase();
        if (apikey) {
            if (userAgent.includes("hustmedia-android")) {
                window.location.href = '/reactapp/selectgoogle';
            } else {
                window.location.href = '/shop/auth/login_google?app=uiviewcontroller&apikey=' + apikey + '&chedo=update';
            }
        }
    };

    const [apikey, setapikey] = useState(null);
    const checkApiKey = () => {
        const apiKey = Cookies.get('apikey');
        if (apiKey !== null) {
            // Có API key, thực hiện các hành động cần thiết
            console.log('Có API key:', apiKey);
            setapikey(apiKey);
            laythongtin(apiKey);
        } else {
            // Không có API key, thực hiện các hành động khác (ví dụ: yêu cầu người dùng nhập API key)
            console.log('Không có API key.');
        }
    };
    const dispatch = useDispatch();
    const set_national_market = (value) => {
        dispatch(update_national_market(value));
    };
    useEffect(() => {
        const national_market_cookie = Cookies.get('national_market');
        if (national_market_cookie) {
            set_national_market(national_market_cookie);
        }
        checkApiKey()
    }, []);
    return (

        <>
            <Helmet>
                <title>Setting Profile</title>
            </Helmet>
            {
                apikey && (
                    <div className="sticky top-14 bg-white">
                        <div style={{ marginLeft: 2, marginRight: 3, alignItems: 'center' }} className="mt-1 mr-20 h-16">
                            <div className="max-h-16">
                                <div className="cards">
                                    <AdSense.Google
                                        client="ca-pub-4574266110812955"
                                        slot="1627514116"
                                        style={{ display: 'block' }}
                                        format='horizontal'
                                        responsive='false'
                                    /></div>
                            </div>
                        </div>
                    </div>

                )
            }
            <View_card
                username={username}
                openpicker={openpicker}
                switch_router={switch_router}
                money={money}
                namelevel={namelevel}
                total_nap={total_nap}
                limit={limit}
                profile={profile}
                openGooglelogin={openGooglelogin}
            />

            {
                !apikey && (
                    <div
                        className="w-full max-w-xl mx-auto p-2 mx-4 rounded-2xl bg-pink-100 text-pink-800 
             dark:bg-gray-800 dark:text-pink-300 shadow-lg border border-pink-200 
             flex items-start gap-3 relative overflow-hidden"
                        role="alert"
                    >

                        {/* floating emojis */}
                        <div className="absolute bottom-1 left-2 text-lg animate-bounce">✨</div>
                        <div className="absolute bottom-1 right-2 text-lg animate-pulse">🌸</div>

                        {/* main icon */}
                        <div className="text-3xl mt-1 animate-[bounce_1.5s_infinite]">📘</div>

                        {/* text */}
                        <div className="leading-snug">
                            <div className="font-bold text-xl">Activity profile Preview</div>
                            <div className="text-base mt-1">
                                This is preview of how your activity profile will appear. 💖✨
                            </div>
                        </div>

                    </div>
                )
            }
            {showpicker && (<>
                <Pickeroption apikey={apikey} showpicker={showpicker} setshowpicker={setshowpicker}
                    chedoprofile={chedoprofile} setchedoprofile={setchedoprofile} handleLogout={handleLogout} />
            </>)}
            <div>
                {/* Các phần khác của trang */}
                <ProfileMenu
                    openpicker={openpicker}
                    handleLogout={handleLogout}
                    openGooglelogin={openGooglelogin}
                />
            </div>
            <br />
        </>

    );
};

export default ProfileComponent;
